import * as React from 'react';
import {useCookies} from 'react-cookie';
import {Warehouse} from '../shared/CommonInterfaces';
import WarehouseSelector from '../shared/WarehouseSelector';
import MovementTasks from '../movements/MovementTasks';
import WarehouseTasks from './WarehouseTasks';

interface TasksPageContainerProps {
  authenticityToken: string;
  warehouse: Warehouse;
  activeWarehouses: Warehouse[];
  inactiveWarehouses: Warehouse[];
  sfsEnabled: boolean;
  useOmniUi?: boolean;
  containerHeader?: string;
  movementsPageSize?: number;
}

/**
 * Container component for the tasks and movement tables. This will choose one of the two component options
 * depending on the FF values
 */
export default function TasksPageContainer(props: TasksPageContainerProps) {
  const [warehouse, setWarehouse] = React.useState<Warehouse>(props.warehouse);
  const [useOmniUi, setUseOmniUi] = React.useState<boolean>(props.useOmniUi || false);
  const [firstLoadPending, setFirstLoadPending] = React.useState<boolean>(true);
  const [cookies, _setCookie, _removeCookie] = useCookies(['selected_warehouse_id']);
  const containerHeader = props.containerHeader || 'Tasks';

  React.useEffect(() => {
    setFirstLoadPending(false);
  }, []);

  React.useEffect(() => {
    if (cookies.selected_warehouse_id) {
      const selectedWarehouseId = parseInt(cookies.selected_warehouse_id, 10);
      const selectedWarehouse =
        props.activeWarehouses.find((w) => w.id === selectedWarehouseId) ||
        props.inactiveWarehouses.find((w) => w.id === selectedWarehouseId);

      if (selectedWarehouse) {
        setWarehouse(selectedWarehouse);
      }
    }
  }, [cookies]);

  return (
    <div className="container-fluid">
      <h1>{containerHeader}</h1>

      {/*
          These components' lifecycles are set up to fetch the selected warehouse's tasks on component mount,
          and it will take more nuanced work to correct their lifecycles to properly switch warehouses on prop change.
          Forcibly re-render the tasks table if the selected warehouse changes.
        */}
      <React.Fragment key={warehouse.id}>
        {useOmniUi ? (
          <WarehouseTasks authenticityToken={props.authenticityToken} warehouse={warehouse} />
        ) : (
          <MovementTasks
            authenticityToken={props.authenticityToken}
            warehouse={warehouse}
            sfsEnabled={props.sfsEnabled}
            movementsPageSize={props.movementsPageSize}
          />
        )}
      </React.Fragment>
    </div>
  );
}
